import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';

class FavMealDish extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        recipe: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
        children: PropTypes.func.isRequired,
    };

    render() {
        const replaceSpanToOl = ({ children }) => (
            <ol>
                <li>{children.slice(3)}</li>
            </ol>
        );

        return (
            <div className="dish">
                <h2 className="title-large semi-bold">{this.props.name}</h2>

                <Row>
                    <Col md="6">{this.props.children()}</Col>

                    {this.props.recipe !== '' ? (
                        <Col md={{ size: 5, offset: 1 }}>
                            <div className="recipe">
                                <p className="semi-bold on-surface text-center text-md-left">
                                    {this.props.t('meal/how-to-prepare')}
                                </p>
                                {this.props.recipe && (
                                    <Markdown
                                        start="1"
                                        options={{
                                            overrides: {
                                                span: {
                                                    component: replaceSpanToOl,
                                                },
                                            },
                                        }}
                                    >
                                        {this.props.recipe}
                                    </Markdown>
                                )}
                            </div>
                        </Col>
                    ) : (
                        ''
                    )}
                </Row>
            </div>
        );
    }
}

export default withLocale(FavMealDish);
